import { useQuery, useMutation, queryCache } from 'react-query';
import request from 'helpers/request';
import queryString from 'query-string';

export const useComponents = () =>
  useQuery('components', async () => {
    const response = await request('/components/?ordering=order');
    return (response && response.results) || [];
  });

export const useComponentGroups = () =>
  useQuery('component-groups', async () => {
    const response = await request('/component-groups/?ordering=order');
    return (response && response.results) || [];
  });

export const useComponentStatuses = () =>
  useQuery('component-statuses', async () => {
    const response = await request('/component-statuses/');
    return (response && response.results) || [];
  });

export const useAccountMembers = () =>
  useQuery('account-members', async () => {
    const response = await request(
      `/account-members/?account_id=${localStorage.getItem(
        'active-account'
      )}&ordering=id`
    );
    return (response && response.results) || [];
  });

export const useAccounts = () =>
  useQuery('accounts', async () => {
    const response = await request('/accounts/');
    return (response && response.results) || [];
  });

export const useAccountById = accountId =>
  useQuery(['accounts', `${accountId}`], async () => {
    if (!accountId) return;
    const response = await request(`/accounts/${accountId}/`);
    return response || {};
  });

export const useAccountsMeta = () =>
  useQuery('accounts-meta', async () => {
    const response = await request('/accounts-meta/');
    return (response && response.results) || [];
  });

export const useAccountMetaById = (accountId, options = {}, queryConfig) =>
  useQuery(
    ['accounts-meta', `${accountId}`],
    async () => {
      const { draft = false, published = false } = options;
      const queryParams = {};
      if (draft) queryParams.draft = true;
      if (published) queryParams.published = true;
      if (!accountId) return;
      const response = await request(
        queryString.stringifyUrl({
          url: `/accounts-meta/${accountId}/`,
          query: queryParams
        })
      );
      return response || {};
    },
    queryConfig
  );

export const useSaveAccountMeta = (options = {}, setToast) =>
  useMutation(
    async ({ payload, id: accountId }) => {
      const queryParams = {};
      if (options && options.draft) queryParams.draft = true;
      if (options && options.published) queryParams.published = true;
      const url = queryString.stringifyUrl({
        url: `/accounts-meta/${accountId}/`,
        query: queryParams
      });
      const response = await request(url, {
        method: 'PATCH',
        payload
      });
      return response;
    },
    {
      onSuccess: (response, { id: accountId, actions }) => {
        if (actions) actions.setSubmitting(false);
        setToast({
          delay: 3000,
          type: 'success',
          text: 'Save success'
        });
        queryCache.setQueryData(['accounts-meta', `${accountId}`], response);
      },
      onMutate: ({ payload, id: accountId }) => {
        queryCache.cancelQueries(['accounts-meta', `${accountId}`]);
        const previousValue = queryCache.getQueryData([
          'accounts-meta',
          `${accountId}`
        ]);
        queryCache.setQueryData(['accounts-meta', `${accountId}`], old =>
          old.account_id === accountId ? payload : old
        );
        return previousValue;
      },
      onError: (err, { id: accountId, actions }, previousValue) => {
        if (actions) actions.setSubmitting(false);
        setToast({
          delay: 3000,
          type: 'error',
          text: 'Save failed'
        });
        queryCache.setQueryData(
          ['accounts-meta', `${accountId}`],
          previousValue
        );
      }
    }
  );
